<h1 mat-dialog-title>Disconnect Patreon?</h1>
<mat-dialog-content>
    <p>
        Are you sure you want to disconnect your Patreon account?
        @if (hasActiveSubscription) {
            <br>
            <b>You will lose access to your in-game perks</b>
        }
    </p>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button (click)="disconnect()">Disconnect</button>
    </mat-dialog-actions>
</mat-dialog-content>